export default __webpack_public_path__ + "static/media/Senait_portrait-min.7a024817.png";